import React from 'react';
import RoleComponent from "../components/roleComponent";
import App from "../App";

const RolePage = () => {
    return (
        <>
            <App/>
            <RoleComponent/>
        </>
    );
};

export default RolePage;